import baseRequest from '../baseRequest';
import AppConfig from '../../app/config/AppConfig';
import { setAllBenefits } from '../../redux/actions';
import {getABParticipationStatus} from "../../app/functions";
import store from "../../redux";

class GetAllBenefits extends baseRequest
{
    constructor() {
        super();
        this.name = 'GetAllBenefits';
        this.dispatch = null;
        this.response = null;
        this.config = new AppConfig();
    }

    execute(dispatch, payload) {
        this.dispatch = dispatch;
        this.payload = payload;
        const { searchConfiguration } = store.getState().config.Parameters;
        const {abTestingPercentageForAllBenefits,apiPath } = searchConfiguration;
        if (getABParticipationStatus('allBenefitsABTestingIncluded', abTestingPercentageForAllBenefits)) {
            this.useNewResponseFormat = true;
            this.call('getAllBenefits', this.payload, 'get', {
                basePath: apiPath,
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                stringifyData: true,
            });
        }else{
            this.call(this.config.api.requests.getAllBenefits, payload);
        }
    }

    onSuccess() {
        this.updateState();
    }

    updateState() {
        this.dispatch(setAllBenefits(this.response.data));
    }
}

export default GetAllBenefits;
